module.exports = __webpack_public_path__ + "static/dinersclub-logo-small-4b04693388f1666dbddba8c44fb51d1c.svg";